import {Fragment, useContext, useMemo, useState} from 'react'

import Nav from './Nav'
import FormFieldCheckbox from './FormFieldCheckbox'
import FormFieldRadio from './FormFieldRadio'
import FormFieldRadioGroup from './FormFieldRadioGroup'
import FormFieldText from './FormFieldText'
import FormFieldTextArea from './FormFieldTextArea'
import FormFieldFile from './FormFieldFile'
import Disclaimer from './Disclaimer'
import AppContext from '../AppContext'
import FormFieldLaitevalinta from './FormFieldLaitevalinta'
import checkConditions from '../checkConditions'

export default function Page (props) {
  const appContext = useContext(AppContext)
  const [ownState, setOwnState] = useState({})

  const state = props.isOwnState ? ownState : appContext.state
  const setState = props.isOwnState ? setOwnState : appContext.setState

  const hasAllRequiredInputs = useMemo(() => {
    if (!props.inputs) return true
    for (const input of props.inputs) {
      if (!input.isRequired) continue
      if (!state[input.name]) return false
    }
    return true
  })

  return (
    <form
      className={"wp-block-gds-lead-form__form"}
      onSubmit={e => {
        e.preventDefault()
        props.onSubmit?.()
      }}
    >
      {props.title && <h2>{props.title}</h2>}
      {props.description && <p>{props.description}</p>}
      {props.inputs?.map((input, index) => (
        <Fragment key={index}>
          {checkConditions(input.conditions, state) && (
            <>
              {input.type === 'radioGroup' ? (
                <FormFieldRadioGroup
                  label={input.label}
                  required={input.isRequired}
                  tooltip={input.tooltip}
                >
                  {input.options.map(option => (
                    <FormFieldRadio
                      key={option.value}
                      value={option.value || ''}
                      label={option.title}
                      description={option.description}
                      checked={state[input.name] === option.value}
                      onChange={() => {
                        state[input.name] = option.value
                        setState({...state})
                      }}
                    />
                  ))}
                </FormFieldRadioGroup>
              ) : input.type === 'checkbox' ? (
                <FormFieldCheckbox
                  label={input.label}
                  required={input.isRequired}
                  tooltip={input.tooltip}
                  value={typeof state[input.name] === 'boolean' ? state[input.name] : false}
                  onChange={val => {
                    state[input.name] = val
                    setState({...state})
                  }}
                />
              ) : input.type === 'text' ? (
                <FormFieldText
                  label={input.label}
                  required={input.isRequired}
                  tooltip={input.tooltip}
                  value={state[input.name] || ''}
                  onChange={val => {
                    state[input.name] = val
                    setState({...state})
                  }}
                />
              ) : input.type === 'textArea' ? (
                <FormFieldTextArea
                  label={input.label}
                  required={input.isRequired}
                  tooltip={input.tooltip}
                  value={state[input.name] || ''}
                  onChange={val => {
                    state[input.name] = val
                    setState({...state})
                  }}
                />
              ) : input.type === 'file' ? (
                <>
                  <FormFieldFile
                    label={input.label}
                    required={input.isRequired}
                    tooltip={input.tooltip}
                    onChange={val => {
                      state[input.name + ' 1'] = val
                      setState({...state})
                    }}
                  />
                  {input.multiple && (
                    <>
                      {(!!state[input.name + ' 1'] || !!state[input.name + ' 2']) && <FormFieldFile
                        required={input.isRequired}
                        onChange={val => {
                          state[input.name + ' 2'] = val
                          setState({...state})
                        }}
                      />}
                      {(!!state[input.name + ' 2'] || !!state[input.name + ' 3']) && <FormFieldFile
                        required={input.isRequired}
                        onChange={val => {
                          state[input.name + ' 3'] = val
                          setState({...state})
                        }}
                      />}
                    </>
                  )}
                </>
              ) : input.type === 'laitevalinta' ? (
                <>
                  <FormFieldLaitevalinta
                    required={input.isRequired}
                    label={input.label}
                    tooltip={input.tooltip}
                    value={state[input.name] || []}
                    options={input.options}
                    onChange={val => {
                      state[input.name] = val
                      setState({...state})
                    }}
                  />
                </>
              ) : null}
            </>
          )}
        </Fragment>
      ))}

      {props.children}

      <Nav
        backLabel={props.backLabel}
        backDisabled={props.backDisabled || props.disabled }
        onBack={props.onBack ? () => props.onBack?.({state, appContext, navigate: props.navigate, setPage: props.setPage}) : undefined}
        nextLabel={props.nextLabel}
        nextDisabled={!hasAllRequiredInputs || props.nextDisabled || props.disabled}
        onNext={props.onNext ? () => props.onNext?.({state, appContext, navigate: props.navigate, setPage: props.setPage}) : undefined}
      />

      {props.disclaimer && <Disclaimer text={props.disclaimer} />}
    </form>
  )
}
